export interface topBannerContentProps {
    h1: string,
    paragraph1: string,
    paragraph2: string
}




export const topBannerData: topBannerContentProps = {
    h1: "Free Wedding Budget Template",
    paragraph1: "Join thousands of happy couples using this resource",
    paragraph2: "Your free wedding budget template and spreadsheet, essential for wedding planning. Available as a Google Sheet or Excel Spreadsheet."
}